import { absolutePath } from "./absolutePath";

export const communityReviews = {
  create: () => absolutePath("community_reviews"),
  prompt: () => absolutePath("community_reviews/prompt"),
  tags: () => absolutePath("community_reviews/tags"),
  dismissPrompt: () => absolutePath("community_reviews/prompt/dismiss"),
  trackPromptImpression: () =>
    absolutePath("community_reviews/prompt/impression"),
};
